var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stat-card',{attrs:{"title":"Total Expense","color":"pink accent-1","amount":_vm.total,"icon":"mdi-cart-outline","sub_title":""}}),_c('stat-card',{attrs:{"title":"GST on Expense","color":"pink accent-2","amount":_vm.gst,"icon":"mdi-cart-outline","sub_title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }